import { jsx as _jsx } from "react/jsx-runtime";
import { Trans } from 'react-i18next';
import { translate } from '../../../../strings/i18n';
import { NoteWrapper } from './subcomponents';
const Note = ({ text }) => (_jsx(NoteWrapper, { all: "base", "data-testid": "sams-note", children: _jsx(Trans, { i18nKey: text, children: translate(`${text}`) }) }));
export default Note;
